/**
 * Which agents this tab has heard a `agent.workstation.changed` frame for.
 *
 * A frame is proof the BE pushes workstation changes and that this tab is
 * connected, which is what lets the Workstation tab stop polling every 15
 * seconds while a box starts. Until a frame arrives for the agent (an older
 * BE that never sends one, a socket that is down) the fast poll stays on.
 * Module state, not React state: it is read from a `refetchInterval`
 * callback and written from the AppShell-level frame handler, neither of
 * which is a render.
 */

const heardFrom = new Set<string>()

export const noteWorkstationFrame = (agentUserId: string): void => {
  heardFrom.add(agentUserId)
}

export const hasHeardWorkstationFrame = (agentUserId: string): boolean => heardFrom.has(agentUserId)

/** Sign-out and tests. */
export const resetWorkstationFrames = (): void => {
  heardFrom.clear()
}
